import { PostModel } from '@/features/blog/types/models/post.model'
import React from 'react'
import { Post } from '../post'

type Props = {
  posts: PostModel[]
}

export const PostList: React.FC<Props> = ({ posts }) => {
  return (
    <ul className='grid grid-cols-1 sm:grid-cols-2'>
      {posts.map(post => (
        <li key={post.id}>
          <Post {...post} className='w-full' />
        </li>
      ))}
    </ul>
  )
}
